import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useEffect } from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { baseTheme } from "./assets/global/Theme-variable";
import ThemeRoutes from "./routes/Router";
import { getConfig } from "./views/profile/config";
import { Auth0ProviderWithNavigate } from "./Auth0Provider";
import { linkContext } from "./views/profile/context";
import { ErrorBoundary } from "react-error-boundary";
import { AppProvider } from "./appContext";
import CursorProvider from "./components/CursorProvider";
import SnackbarContext from "./context/SnackbarContext";
import { UserContextProvider } from "./context/UserContext";
import Main from "./Main";
import { MyFallbackComponent } from "./views/FallBackComponent";

const App = () => {
  const theme = baseTheme;
  const [someKey, setSomeKey] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: [],
    duration: 3000,
    severity: "success",
  });

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  const config = getConfig();
  const mainProviderConfig = {
    domain: config.domain,
    // prompt: log
    clientId: config.clientId,
    authorizationParams: {
      redirect_uri: `${window.location.origin}`,
      skipRedirectCallback: window.location.href.includes("?secondary"),
      scope:
        "openid email profile offline_access read_all write_all read:current_user			update:current_user update:current_user_metadata update:current_user_identities",
      ...(config.audience ? { audience: config.audience } : null),
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    cacheLocation: "localstorage",
    responseType: "token id_token",
  };

  const linkProviderConfig = {
    domain: config.domain,
    clientId: config.clientId,
    context: linkContext,
    authorizationParams: {
      scope: "openid email profile",
      redirect_uri: `${window.location.origin}?secondary`,
      skipRedirectCallback: window.location.href.includes("?primary"),
      audience: `MaxCloud`,
    },
    // cacheLocation: "localstorage",
    useRefreshTokens: true,
    responseType: "token id_token",
  };

  const Auth0ProviderWithLayout = () => (
    <ErrorBoundary
      FallbackComponent={MyFallbackComponent}
      onReset={() => setSomeKey(null)}
      onError={logErrorToService}
      resetKeys={[someKey]}
    >
      <Auth0ProviderWithNavigate
        mainProviderConfig={mainProviderConfig}
        linkProviderConfig={linkProviderConfig}
      >
        <Main />
      </Auth0ProviderWithNavigate>
    </ErrorBoundary>
  );

  const Routes = [
    {
      element: <Auth0ProviderWithLayout />,
      children: ThemeRoutes,
    },
  ];

  const router = createHashRouter(Routes);

  function logErrorToService(error, info) {
    console.log("Caught an error:", error, info);
  }
  return (
    <CssBaseline>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <CursorProvider>
            <SnackbarContext.Provider value={{ snackbar, setSnackbar }}>
              <UserContextProvider>
                <RouterProvider router={router} />
              </UserContextProvider>
            </SnackbarContext.Provider>
          </CursorProvider>
        </AppProvider>
      </ThemeProvider>
    </CssBaseline>
  );
};

export default App;
